
        var result = require("!!../../../../node_modules/css-loader/index.js!./reset-password.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/reset-password/reset-password.component.css
// module id = 720
// module chunks = 0